__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['multi-model-voice-response-application'].baseUrl;
import ModuleContainer from './components/Mmvr';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}